import React,{useState,useEffect} from 'react'
import add from '../../../../assets/images/add.png'
import {useHistory} from 'react-router-dom';
import $ from "jquery";
import Api from "../../../../apis/apis";
import Notifications from "../../../../notifications/notifications";


function Chat() {

    let history=useHistory();

    let [chat,setChat]=useState(null);

    useEffect(async ()=>{

        let res=await Api.allChat();
        if (res.status == '200')
        {
            setChat(res.data);

        }

        //initialize datatable
        $(document).ready(function () {
            setTimeout(function(){
                $('#example').DataTable();
            } ,500);
        });
    },[])




    async function deleteChat(id) {
        let data={
            id: id
        }

        let res= await Api.deleteChat(data);
        console.log(res);

        if (res.status == '200')
        {
            await Notifications.successMsg(res.message);
            await refreshRecord();
        }
    }

    async function refreshRecord() {
        let res=await Api.allChat();
        if (res.status == '200')
        {
            setChat(res.data);

        }
    }

    // function editAffiliate(id) {
    //     console.log(id)
    //     sessionStorage.setItem('affiliateId',id);
    //     history.push('/edit-affiliate')
    // }

    return (
        <>
            <div className='driver-head'>
                <h3 className='dashboard-head-title'>Users</h3>
                <div>
                    {/*<div className='nav-buttons'>*/}
                    {/*    <button onClick={()=>history.push('/add-user')} style={{ background: '#FF7B00', marginRight: '15px' }}><img src={add} alt="" />  Add Users</button>*/}
                    {/*</div>*/}
                </div>
            </div>
            <div className='dashboard-table-wrapper_ p-3'>
                <table id="example" className="table table-hover table-bordered" style={{overFlow:"auto"}}>
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Sender</th>
                        <th>Receiver</th>
                        <th>Message</th>
                        <th>Delete</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        chat?.map((itm,i)=>(
                            <tr key={i}>
                                <td>{itm.id}</td>
                                <td>{itm.senderID}</td>
                                <td>{itm.recieverId}</td>
                                <td>{itm.message}</td>
                                <td><i onClick={()=>{deleteChat(itm.id)}} className={'fas fa-trash'} style={{cursor: "pointer",color: "red"}}></i></td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default Chat